import React from 'react'
import { useForm } from 'react-hook-form'
import { SearchOutlined } from '@ant-design/icons'

import { LntButton, LntForm, LntFormItem, LntInput, LntSelect } from '@app/components/base'

import { Icon } from '@app/components/util'

import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { BUTTON_TYPE, SIZE } from '@app/constants'
import { ICON_NAME } from '@app/constants/icon'

import styles from './styles.module.scss'

import type { AddProductsFormData, AddProductsFormProps } from './types'
import type { FilterOption } from '@app/types/filter'

const filterOptions: FilterOption[] = [
  {
    value: 'purchasingGroupCodes',
    label: 'Группа закупок'
  },
  {
    value: 'commodityGroupCodes',
    label: 'Товарная группа'
  },
  {
    value: 'categoryCodes',
    label: 'Категория'
  },
  {
    value: 'subcategoryCodes',
    label: 'Подкатегория'
  },
  {
    value: 'productCodes',
    label: 'Код товара'
  }
]

const DEFAULT_VALUES: AddProductsFormData = {
  filterName: 'productCodes',
  filterValue: ''
}

export const AddProductsForm: React.FC<AddProductsFormProps> = ({ onSubmit }) => {
  const form = useForm<AddProductsFormData>()
  const isExistValue = !!form.watch('filterValue')

  const handleResetFilter = (): void => {
    form.reset(DEFAULT_VALUES)
  }

  const handleSubmit = (): void => {
    const filterName = form.getValues().filterName
    const filterValue = form.getValues().filterValue

    onSubmit({ [filterName]: filterValue })
  }

  return (
    <LntForm
      className={ styles.addProductsForm__filters }
      onSubmit={ handleSubmit }
      formInstance={ form }
    >
      <div className={ styles.addProductsFormFilters__wrapper }>
        <LntFormItem
          name='filterName'
          defaultValue={ DEFAULT_VALUES.filterName }
        >
          <LntSelect
            placeholder={ FILTERS_PLACEHOLDERS.monitoringsTypeFilter }
            options={ filterOptions }
            showArrow
            size={ SIZE.middle }
          />
        </LntFormItem>
        <LntFormItem
          name='filterValue'
          defaultValue=''
        >
          <LntInput
            placeholder='Значение фильтра'
            size={ SIZE.middle }
          />
        </LntFormItem>
      </div>
      <div className={ styles.addProductsFormFilters__buttons }>
        <LntButton
          icon={ <SearchOutlined /> }
          type={ BUTTON_TYPE.primary }
          size={ SIZE.middle }
          htmlType='submit'
          disabled={ !isExistValue }
        >
          Найти
        </LntButton>

        <LntButton
          htmlType='reset'
          type={ BUTTON_TYPE.textDanger }
          size={ SIZE.middle }
          disabled={ !isExistValue }
          onClick={ handleResetFilter }
          icon={ <Icon name={ ICON_NAME.resetSearch } /> }
        >
          Сбросить
        </LntButton>
      </div>
    </LntForm>
  )
}
